
import React from 'react';
import { History } from 'lucide-react';
import { VideoEvent } from '@/hooks/useVideoEvents';
import { format } from 'date-fns';
import { fr } from 'date-fns/locale';

interface HistoryTabProps {
  video: VideoEvent;
}

const HistoryTab: React.FC<HistoryTabProps> = ({ video }) => {
  const formattedDate = video.date ? 
    format(video.date, 'd MMMM yyyy à HH:mm', { locale: fr }) : 
    'Date inconnue';
    
  return (
    <div className="p-6">
      <div className="flex items-center gap-2 mb-4">
        <History className="h-5 w-5 text-blue-500" />
        <h3 className="text-lg font-medium">Historique</h3>
      </div>
      
      <div className="space-y-4">
        <div className="flex gap-4 items-start">
          <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center shrink-0">
            <History className="h-5 w-5 text-blue-500" />
          </div>
          <div>
            <p className="font-medium">Vidéo publiée</p>
            <p className="text-sm text-gray-500">{formattedDate}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HistoryTab;
